import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Shubham Srivastava',
    title: "Full Stack Web Developer",
    desciption:"One of the lessons that I grew up with was to always stay true to yourself and never let what somebody else says distract you from your goals.",
    image: 'https://media-exp1.licdn.com/dms/image/C4E03AQHFJkWg0FIgLw/profile-displayphoto-shrink_800_800/0/1639731568801?e=1646870400&v=beta&t=YWPDGwgvND_0F-FKa862pcasaPpTfsZDn2HPK2dQ89c',
    resumePdf: resume
}
